(function () {
  // Inject modal HTML into DOM on load if it doesn't exist
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.getElementById('personalised-disclaimer-modal')) {
      const modalHTML = `
        <div id="personalised-disclaimer-modal" class="reco-modal personalised-disclaimer-modal reco-hidden">
          <div class="reco-modal-content">
            <div id="reco-modal-message" class="reco-modal-message"></div>
            <div class="reco-modal-actions">
              <button id="reco-modal-confirm" class="reco-btn">Proceed</button>
              <button id="reco-modal-cancel" class="reco-btn reco-btn--secondary">Cancel</button>
            </div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHTML);
    }
  });

  window.personalised = window.personalised || {};
  window.personalised.disclaimerModal = {
    /**
     * Hiển thị modal cảnh báo nếu có allergy hoặc pregnancy
     * Trả về Promise<boolean>: true nếu user nhấn Continue, false nếu Cancel
     */
    showDisclaimerModal: function ({ allergy, pregnancy }) {
      return new Promise((resolve) => {
        const modal = document.getElementById('personalised-disclaimer-modal');
        const messageBox = document.getElementById('reco-modal-message');

        if (!modal || !messageBox) {
          console.error('[DisclaimerModal] Modal or content not found');
          return resolve(false);
        }

        const messages = [];
        if (pregnancy && !['no', 'none', ''].includes(pregnancy.toLowerCase().trim())) {
          messages.push(`<p>You mentioned that you are ${pregnancy}. Some vitamins and/or supplements may not be right for you. Read the label and any warnings before adding products to your pack. We recommend consulting your health professional before starting a vitamin and supplement routine.</p>`);
        }
        if (allergy && !['no', 'none', ''].includes(allergy.toLowerCase().trim())) {
          messages.push(`<p>You mentioned that you are allergic to ${allergy}. Read each product label carefully before adding products to your pack.</p>`);
        }

        messageBox.innerHTML = messages.join('') || '<p>No warnings detected.</p>';

        // Hiển thị modal
        modal.classList.remove('reco-hidden');

        const closeModal = () => {
          modal.classList.add('reco-hidden');
        };

        // Confirm: tiếp tục hành động
        const confirmBtn = modal.querySelector('#reco-modal-confirm');
        const cancelBtn = modal.querySelector('#reco-modal-cancel');

        const handleConfirm = () => {
          cleanup();
          resolve(true);
        };

        /**
         * Handle Cancel button click - simply close the modal without clearing any state
         * Preserves bundle state, recommendation data, and user preferences
         */
        const handleCancel = () => {
          // Simply close the modal and resolve with false
          console.info('[DisclaimerModal] User cancelled add to pack');
          
          cleanup();
          resolve(false);
        };

        const cleanup = () => {
          closeModal();
          confirmBtn.removeEventListener('click', handleConfirm);
          cancelBtn.removeEventListener('click', handleCancel);
        };

        confirmBtn.addEventListener('click', handleConfirm);
        cancelBtn.addEventListener('click', handleCancel);
      });
    }
  };
})();
